import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import AlertIcon from '../AlertIcon';
import MenuIcon from '@material-ui/icons/Menu';
import List from '@material-ui/core/List';
import Typography from '@material-ui/core/Typography';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Fade from '@material-ui/core/Fade';
import AlertList from '../AlertList/AlertList';
import ThresholdSetting from '../ThresholdSetting';
import { formatDateTime } from '../../utils/format-time';
import { styles } from '../../styles/drawer-list-styles';
import { fetchAlertsByMonitorId, createActiveAlerts, reduceAlertsToDateRange, processAllAlerts, checkForCriticalAlerts} from '../../utils/alerts';
import { updateAlert } from '../../utils/api'
import Loading from '../Loading';
import { Badge } from '@material-ui/core';

export class AlertDrawer extends React.Component {
  state = {
    left: false,
    alertButtonColor: "disabled",
    alerts: [],
    clearButtonDisabled: false,
    clearButtonText: "Clear All",
    alertsLoading: true
  };

  sortAlerts = (alerts) => {
    if(alerts) {
    return alerts.sort((a, b) => {
      return b.time - a.time;
    })
  } else return null;
  }
  setStateValues = () => {
      const alerts = alerts ? this.props.alerts.sort((a, b) => {
          return b.time - a.time;
        }) :
        this.props.alerts;
    const alertButtonColor = this.setAlertButtonColor(this.props.alerts, this.props.activeAlerts);
    let clearButtonDisabled = false;
    if(this.props.activeAlerts.length === 0) {
      clearButtonDisabled = true;
    }
    this.setState({
      alerts,
      alertButtonColor,
      clearButtonDisabled,
    })
  }

  handleClearAllAlerts = () => {
    this.setState({
      clearButtonText: "Clearing..."
    })
    const alerts = this.state.alerts;
    const clearAlerts = processAllAlerts(alerts, this.props.monitorId, this.props.updateAlertInState, true)
    this.setNewAlerts(clearAlerts);
    this.props.fetchMonitors();
  }

  handleUpdateAlert = (alert) => {
    alert.cleared = !alert.cleared;
    const alertToUpdate = { monitorId: this.props.monitorId, alert,};
    this.props.updateAlertInState(alertToUpdate);
    updateAlert(alert);
  }

  handleAlertsLoading = () => {

  }
  setNewAlerts = (alerts) => {
    const sortedAlerts = alerts.sort((a, b) => {
      return b.time - a.time;
    })
    this.props.handleAlerts(sortedAlerts, this.props.rangeSetting);
    const activeAlerts = createActiveAlerts(sortedAlerts);
    const alertButtonColor = this.setAlertButtonColor(sortedAlerts, activeAlerts);
    this.setState({
      alerts: sortedAlerts,
      alertButtonColor,
      clearButtonText: "Clear all"
    })
  }

  setAlertButtonColor = (alerts, activeAlerts) => {
    if(alerts) {
      if(alerts.length !== 0) {
        if(activeAlerts.length !== 0) {
          return 'secondary';
        } else {
          return 'primary';
        }
      } else {
        return "inherit";
      }
    } else return "inherit";
  }

  setClearButton = () => {
    if(this.props.activeAlerts.length === 0) {
      this.setState({
        clearButtonDisabled: true
      })
    }
  }
  toggleDrawer = (side, open) => () => {
    this.setState({
      [side]: open,
    });
  };
  componentDidMount() {
    this.setStateValues();  
  }
  componentDidUpdate(prevProps) {
    if(prevProps !== this.props) {
      this.setStateValues();
    }
  }
  render() {
    const critical = this.props.type === "transfer" ? checkForCriticalAlerts(this.props) : false;
    const badgeInvisible = this.props.activeAlerts.length > 0 ? false : true;
    const { classes } = this.props;
    return (
      <div>    
          <IconButton onClick={this.toggleDrawer('left', true)}>
            <Badge 
              classes={{badge: classes.badge}} 
              invisible={badgeInvisible} 
              badgeContent={this.props.activeAlerts.length} 
              overlap="circle"
              color="secondary"
              >
            <AlertIcon color={this.state.alertButtonColor} critical={critical} />
            </Badge>
          </IconButton>            
        <SwipeableDrawer
          open={this.state.left}
          onClose={this.toggleDrawer('left', false)}
          onOpen={this.toggleDrawer('left', true)}
        >
          <div className={classes.root}>
            <AppBar position="static">
              <Toolbar className={classes.toolbar}>
                <Typography variant="h6" className={classes.title}>
                  {this.props.title}
                </Typography>
                <Button 
                  size="small"
                  onClick={() => {this.handleClearAllAlerts()}}
                  disabled={this.state.clearButtonDisabled}
                >
                  {this.state.clearButtonText}
                </Button>
              </Toolbar>
            </AppBar>
          </div>
          <div className={classes.thresholdContainer}>
            <ThresholdSetting 
              unit={this.props.unit} 
              alertCutoff={this.props.alertCutoff} 
              monitorId={this.props.monitorId} 
              handleAlertCutoffChange={this.props.handleAlertCutoffChange}
              handleAlertsLoading={this.handleAlertsLoading}
              handleDeleteAlertsFromState = {this.props.handleDeleteAlertsFromState} />
          </div>
          <Fade in={true} timeout={1500}>
            { 
              !this.props.alerts ? 
              <Loading /> :           
              <div
                tabIndex={0}
                role="button"
              >
                <AlertList alerts={this.sortAlerts(this.state.alerts)} handleUpdateAlert={this.handleUpdateAlert} type={this.props.type} />
              </div>
            }
          </Fade>
        </SwipeableDrawer>
      </div>
    );
  }
}

AlertDrawer.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(AlertDrawer);



// WEBPACK FOOTER //
// ./src/components/AlertDrawer/AlertDrawer.js